import React from "react";
import { Landmark, ShieldCheck } from "lucide-react";
import { EditorialIcon } from "./EditorialVisuals";

export const Table = ({ columns, rows, variant, testId, icons = [] }) => (
  <table className={`tbl${variant ? ` tbl--${variant}` : ""}`} data-testid={testId}>
    <thead>
      <tr>
        {columns.map((c, index) => (
          <th key={c} scope="col" data-testid={testId ? `${testId}-heading-${index + 1}` : undefined}>
            <span className="table-heading">
              {icons[index] ? <EditorialIcon icon={icons[index]} testId={`${testId}-icon-${index + 1}`} /> : null}
              {c}
            </span>
          </th>
        ))}
      </tr>
    </thead>
    <tbody>
      {rows.map((r, i) => (
        <tr key={i}>
          {r.map((cell, j) => (
            <td key={j} data-label={columns[j]}>
              {cell}
            </td>
          ))}
        </tr>
      ))}
    </tbody>
  </table>
);

export const COMPARE_COLUMNS = ["Regulation", "Insulation"];
export const COMPARE_ROWS = [
  ["Rules set by others, enforced after the fact", "Controls you own, enforced before harm"],
  ["Set by governments and blocs", "Set by the enterprise, the community, the individual"],
  ["Arrives years after the technology, if at all", "Available now, while regulation is still being written"],
  ["Penalties once harm has occurred", "Gates that stop the action before it happens"],
  ["Serves the jurisdiction that wrote it", "Serves whoever put it in place"],
];

export const CompareTable = ({ testId = "compare-table" }) => (
  <Table columns={COMPARE_COLUMNS} rows={COMPARE_ROWS} variant="compare" testId={testId} icons={[Landmark, ShieldCheck]} />
);

export const Numbered = ({ items, plain = false, testId, icons = [] }) => (
  <ol className={`numbered${plain ? " numbered--plain" : ""}${icons.length ? " numbered--illustrated" : ""}`} data-testid={testId}>
    {items.map((it, i) => (
      <li key={i} data-testid={testId ? `${testId}-item-${i + 1}` : undefined}>
        {icons[i] ? (
          <span className="numbered-emblem" aria-hidden="true">
            <EditorialIcon icon={icons[i]} testId={`${testId}-icon-${i + 1}`} />
            <span className="numbered-index">{String(i + 1).padStart(2, "0")}</span>
          </span>
        ) : null}
        <div>
          <div className="numbered-title">{it.title}</div>
          {it.body ? <div className="numbered-body">{it.body}</div> : null}
        </div>
      </li>
    ))}
  </ol>
);
